import APP_ACTIONS from '../constants/app-actions';

const initialState = {};

const user = (state = initialState, action) => {
    switch (action.type) {
    case APP_ACTIONS.USER:
        return { ...state, ...action.payload };
    case APP_ACTIONS.REMOVE_USER:
        return initialState;
    default:
        return state;
    }
};

export default user;



/** WEBPACK FOOTER **
 ** ./src/reducers/user.js
 **/